import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Navigate, Route, Router, Routes, BrowserRouter } from 'react-router-dom';

//styles maquinas
import { errorMachine, PromiseSesionContext } from './machines/ErrorMachine';
import { useMachine } from '@xstate/react';
import ErrorHandler from './errorHandler/ErrorHandler';
import Layout from './pageLayout/Layout';
import Products from './pages/products/Products';
import { sesionMachine } from './machines/SesionMachine';
import Inventario from './pages/inventario/Inventario';
import CreateProduct from './pages/createProduct/CreateProduct';
import Welcome from './pages/welcome/Welcome';
import { GlobalDataProvider } from './context/GlobalContext';
import Auth from './pages/auth/Auth';
import RolGuard from './guard/RolGuard';
import UpdateProduct from './pages/updateProduct/UpdateProduct';

function App() {
  const [error, sendError] = useMachine(errorMachine)
  const [sesion, sendSesion] = useMachine(sesionMachine)


  return (
    <GlobalDataProvider>
      <BrowserRouter>
        <PromiseSesionContext.Provider value={{ error, sendError, sesion, sendSesion}}>
          <ErrorHandler>
            <RolGuard>
              <Layout>
                <Routes>
                  {/* <Route path='/inicio' element={<Welcome />} /> */}
                  <Route path='/' element={<Products />} />
                  <Route path='/ingresar' element={<Auth />} />



                  {/* admin */}
                  <Route path='/inventario' element={<Inventario />} />
                  <Route path='/crear-producto' element={<CreateProduct />} />
                  <Route path='/actualizar_producto/:id' element={<UpdateProduct />} />






                  <Route path="*" element={<Navigate to="/" replace />}/>
                </Routes>
              </Layout>
            </RolGuard>
          </ErrorHandler>
        </PromiseSesionContext.Provider>
      </BrowserRouter>
    </GlobalDataProvider>
  );
}

export default App;
